import { render, staticRenderFns } from "./yyzx.vue?vue&type=template&id=510f360e&scoped=true&"
import script from "./yyzx.vue?vue&type=script&lang=js&"
export * from "./yyzx.vue?vue&type=script&lang=js&"
import style0 from "./yyzx.vue?vue&type=style&index=0&id=510f360e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510f360e",
  null
  
)

export default component.exports